import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HelpersService } from 'libs/shared/src/lib/services/helpers.service';

@Component({ standalone: false,
  selector: 'vfa-cp-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {

  constructor(public translate: TranslateService, 
              public helpersService: HelpersService) {
  }

  ngOnInit(): void {
    // const url = (document.getElementsByTagName('base')[0] || {}).href;
    // const url = (document.getElementsByTagName('base')[0] || {}).href.replace(/(^\w+:|^)\/\//, '').replace(/\/$/, "");
    // this.helpersService.getSettings(url).subscribe((res) => {
    //   this.helpersService.applyTheme(res.settings);
    // })
  }
}

